<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/party/building_add')"
      >添加</el-button
    >
    <el-button
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >
    <el-select
      filterable
      style="float: right"
      v-model="screen.type"
      placeholder="请选择类型"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.title"
        :value="item.id"
        v-for="(item, index) in typeList"
        :key="index"
      ></el-option>
    </el-select>
    <!-- <el-select filterable 
      style="float: right; margin-right: 10px"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      @change="parkChange"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-input
      style="float: right; margin-right: 10px; width: 200px"
      v-model="screen.title"
      placeholder="标题"
    ></el-input>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "文化墙"
              : scope.row.type == 2
              ? "党建要闻"
              : scope.row.type == 3
              ? "学习园地"
              : scope.row.type == 4
              ? "党群活动"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.park ? scope.row.park.name : "" }}</span> -->
          <span>{{ scope.row.park_text }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发布时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.release_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="浏览量">
        <template slot-scope="scope">
          {{ scope.row.view_num }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '2'
                ? 'success'
                : scope.row.status == 3
                ? 'danger'
                : scope.row.status == 1
                ? 'info'
                : ''
            "
            disable-transitions
            >{{
              scope.row.status == 2
                ? "发布"
                : scope.row.status == 3
                ? "下架"
                : "待发布"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/party/building_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/party/building_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/party/building_del')"
            >删除</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="statusEdit(scope.row)"
            v-if="roles.includes('/party/building_status')"
            >改变状态</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="类型" prop="type">
          <el-select
            filterable
            v-model="ruleForm.type"
            placeholder="请选择类型"
            @change="typeChange"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in typeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择活动"
          prop="activity_id"
          v-if="ruleForm.type == 4"
        >
          <el-select
            filterable
            v-model="ruleForm.activity_id"
            placeholder="请选择活动"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in activityList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.type != 4">
          <el-form-item label="选择园区" prop="park_ids">
            <el-select
              filterable
              multiple
              collapse-tags
              v-model="ruleForm.park_ids"
              placeholder="请选择园区"
              :disabled="cztype == 'see' || userInfo.park_id != 0"
              @change="formParkChange"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in parkList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="标题" prop="title">
            <el-input
              class="w4"
              v-model="ruleForm.title"
              placeholder="请输入标题"
              :disabled="cztype == 'see'"
            ></el-input>
          </el-form-item>
          <el-form-item label="性质" prop="xingzhi" v-if="ruleForm.type == 2">
            <el-input
              class="w4"
              v-model="ruleForm.xingzhi"
              placeholder="请输入要闻性质"
              :disabled="cztype == 'see'"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item
          label="文化墙类型"
          prop="type_one"
          v-if="ruleForm.type == 1"
        >
          <el-radio-group
            v-model="ruleForm.type_one"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">视频</el-radio>
            <el-radio :label="2">图文</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="图片"
          prop="picurl"
          v-if="
            ruleForm.type != 1 || (ruleForm.type == 1 && ruleForm.type_one == 2)
          "
        >
          <el-upload
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :class="ruleForm.picurl && ruleForm.type != 4 ? 'hide' : ''"
          >
            <!-- <img
              v-if="ruleForm.thumb"
              :src="imageUrl + ruleForm.thumb"
              class="avatar-uploaders"
            /> -->
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item
          label="视频"
          prop="video"
          v-if="ruleForm.type == 1 && ruleForm.type_one == 1"
        >
          <el-upload
            name="file[]"
            :data="{ type: 'video' }"
            :action="ossUpload"
            :headers="{ token: token }"
            accept="video/mp4"
            list-type="picture-card"
            :show-file-list="false"
            :on-error="videoErr"
            :on-progress="videoProgross"
            :on-success="handleVideoSuccess"
            :disabled="cztype == 'see'"
          >
            <el-progress
              v-if="percentage != 0 && percentageShow"
              type="circle"
              :percentage="percentage"
            ></el-progress>
            <div class="video-box" v-if="ruleForm.video">
              <div class="handles">
                <i class="el-icon-delete" @click.stop="delVideo"></i>
              </div>
              <video controls :src="imageOss + ruleForm.video" />
            </div>
            <i class="el-icon-plus avatar-uploader-icon" v-else></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item
          label="内容"
          prop="content"
          v-if="
            ruleForm.type == 2 ||
            ruleForm.type == 3 ||
            (ruleForm.type == 1 && ruleForm.type_one == 2)
          "
        >
          <Editor
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item label="发布状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">待发布</el-radio>
            <el-radio :label="2">发布</el-radio>
            <el-radio :label="3">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button v-if="cztype != 'add'" type="info" @click="drawer = false">
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      title="改变状态"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        ref="statusForm"
        :model="statusForm"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item
          label="状态"
          prop="status"
          :rules="[
            { required: true, message: '请选择状态', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="statusForm.status">
            <el-radio :label="1">待发布</el-radio>
            <el-radio :label="2">发布</el-radio>
            <el-radio :label="3">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="statusBtn()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, delImage } from "@/api/index";
import {
  building_add,
  building_edit,
  building_list,
  building_del,
  building_info,
  building_status,
  activity_lists,
} from "@/api/party";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        type: "",
        title: "",
      },
      typeList: [
        {
          title: "文化墙",
          id: 1,
        },
        {
          title: "党建要闻",
          id: 2,
        },
        {
          title: "学习园地",
          id: 3,
        },
        {
          title: "党群活动",
          id: 4,
        },
      ],
      total: 0,
      ruleForm: {},
      fileList: [],
      rules: {
        park_ids: [
          {
            type: "array",
            required: true,
            message: "请选择园区",
            trigger: "change",
          },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        picurl: [{ required: true, message: "请选择图片" }],
        status: [{ required: true, message: "请选择状态" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        xingzhi: [{ required: true, message: "请输入要闻性质", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        video: [{ required: true, message: "请选择视频", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      clearPics: [],
      registerUser: {
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerUserList: [],
      activityList: [],
      percentage: 0,
      percentageShow: true,
      clearVideos: [],
      statusForm: {
        id: "",
        status: "",
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
    this.getActivity();
  },
  methods: {
    statusEdit(val) {
      this.statusForm = {
        id: val.id,
        status: val.status,
      };
      this.dialogVisible = true;
    },
    // 改变状态
    statusBtn() {
      building_status(this.statusForm).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.fetchData();
          this.dialogVisible = false;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    // parkChange(e) {
    //   this.screen.type_id = "";
    // },
    typeChange() {
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.ruleForm.video = "";
      this.ruleForm.picurl = "";
    },
    formParkChange(e) {
      this.ruleForm.type_id = "";
    },
    getActivity(e) {
      let data = {
        park_id: "",
        is_party: 1,
      };
      if (this.userInfo.park_id !== 0) {
        data.park_id = this.userInfo.park_id;
      }
      activity_lists(data).then((res) => {
        this.activityList = res.data.lists.data;
      });
    },
    delVideo() {
      this.clearVideos.push(this.ruleForm.video);
      this.ruleForm.video = "";
    },
    videoProgross(e) {
      this.percentage = parseInt(e.percent);
    },
    handleVideoSuccess(res, file, fileList) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.picurl = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearVideos.length) {
        delImage({ file: this.clearVideos.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm.picurl = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    reset() {
      this.screen = {
        title: "",
        type: "",
        page: 1,
        page_size: 15,
      };

      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.ruleForm.type == 1) {
            if (that.ruleForm.type_one == 1) {
              that.ruleForm.picurl = "";
            } else {
              that.ruleForm.video = "";
            }
          }
          if (that.ruleForm.type == 4) {
            that.ruleForm.activity_picurl = that.ruleForm.picurl.split(",");
            // that.ruleForm.picurl = "";
          } else {
            that.ruleForm.activity_picurl = "";
          }
          that.ruleForm.park_id = that.ruleForm.park_ids.toString();
          this.$confirm("确认提交？")
            .then(() => {
              building_edit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.code,
                    type: "success",
                  });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },

    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      building_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.info.id,
          park_ids: [],
          picurl: res.data.info.picurl,
          video: res.data.info.video,
          status: res.data.info.status,
          title: res.data.info.title,
          content: res.data.info.content,
          type: res.data.info.type,
          type_one: res.data.info.type_one,
          is_super: this.userInfo.is_super,
          activity_id: res.data.info.activity_id,
          xingzhi:res.data.info.xingzhi
        };
        if (res.data.info.select_parks) {
          res.data.info.select_parks.forEach((element) => {
            that.ruleForm.park_ids.push(element.id);
          });
        }
        var list;
        if (res.data.info.type == 4) {
          that.ruleForm.picurl = res.data.info.activity_picurl;
          list = res.data.info.activity_picurl.split(",");
        } else {
          list = res.data.info.picurl.split(",");
        }
        this.fileList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          building_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.ruleForm.type == 1) {
            if (that.ruleForm.type_one == 1) {
              that.ruleForm.picurl = "";
            } else {
              that.ruleForm.video = "";
            }
          }
          if (that.ruleForm.type == 4) {
            that.ruleForm.activity_picurl = that.ruleForm.picurl.split(",");
            // that.ruleForm.picurl = "";
          } else {
            that.ruleForm.activity_picurl = "";
          }
          that.ruleForm.park_id = that.ruleForm.park_ids.toString();
          // return
          this.$confirm("确认提交？")
            .then(() => {
              building_add(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_ids: [],
        title: "",
        content: "",
        type: "",
        status: "",
        type_one: 2,
        picurl: "",
        video: "",
        xingzhi:"",
        activity_id: "",
        activity_picurl: "",
        is_super: this.userInfo.is_super,
      };
      this.clearPics = [];
      this.fileList = [];
      this.clearVideos = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_ids.push(this.userInfo.park_id);
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      building_list(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
